import { DataPoints, FlowTypeDataPoint } from '@web-config-app/core';
import { userProfileDataPoints } from './data-points/user-profile-data-points';
import { campaignCompletionDataPoints } from './data-points/campaign-completion-data-points';
import { rewardDataPoints } from './data-points/reward-data-points';

const activityDataPoints: FlowTypeDataPoint = {
  id: 'config-activity',
  description: 'data points for activities',
  dataHandlers: [{ id: 'local', description: '', version: '' }],
  dataPoints: [...rewardDataPoints, ...campaignCompletionDataPoints],
};

const campaignDataPoints: FlowTypeDataPoint = {
  id: 'config-campaign',
  description: 'data points for campaigns',
  dataHandlers: [{ id: 'local', description: '', version: '' }],
  dataPoints: [...userProfileDataPoints, ...campaignCompletionDataPoints],
};

// Member data points a member-outreach questionnaire can gate branching /
// visibility on. Explicitly allowlisted to up.age rather than relying on the
// conditionSubject's `dataTypes` filter — otherwise a new number-typed profile
// data point added to userProfileDataPoints would be silently surfaced here.
// Widen this list (e.g. add up.sex) in lockstep with the backend registry that
// can resolve it.
const OUTREACH_QUESTIONNAIRE_DATA_POINT_IDS = ['up.age'];
const outreachQuestionnaireDataPoints = userProfileDataPoints.map((group) => ({
  ...group,
  dataPoints: (group.dataPoints ?? []).filter((dp) =>
    OUTREACH_QUESTIONNAIRE_DATA_POINT_IDS.includes(dp.id),
  ),
}));

const masonryQuestionnaireDataPoints: FlowTypeDataPoint = {
  id: 'config-masonry-questionnaire',
  description: 'data points for member outreach questionnaires',
  dataHandlers: [{ id: 'local', description: '', version: '' }],
  dataPoints: outreachQuestionnaireDataPoints,
};

export const commonDataPoints: DataPoints = [
  campaignDataPoints,
  activityDataPoints,
  masonryQuestionnaireDataPoints,
];
